// The point of this package is to be a noop output for 'angular' package so that @uirouter/angularjs doesn't include the whole angular library
// in the build output, and instead just uses the global already on the page (from a <script>).
// The version is just set to be the last stable version of angular.js, since it's now EOL.
if (!window.hasOwnProperty('angular')) {
    throw new Error('angular is not available, so angular-noop is not being used correctly, or is unnecessary');
}
console.log('loading angular-noop, because angular is already loaded elsewhere');
module.exports = undefined;
